import { render, staticRenderFns } from "./NoAlarmView.vue?vue&type=template&id=6f44f265&"
import script from "./NoAlarmView.vue?vue&type=script&lang=js&"
export * from "./NoAlarmView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/christoph/workspace/nextcloud/apps/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f44f265')) {
      api.createRecord('6f44f265', component.options)
    } else {
      api.reload('6f44f265', component.options)
    }
    module.hot.accept("./NoAlarmView.vue?vue&type=template&id=6f44f265&", function () {
      api.rerender('6f44f265', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Editor/Alarm/NoAlarmView.vue"
export default component.exports